import React from "react";
import { faWifi } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TableCell, TableRow } from "../../components/Table";
import { Client } from "../../redux/centers/centers-types";
import ExpandIcons from "../../components/ExpandIcons";
import { borders, colors } from "../../theme";
import CentersInfo from "./CentersInfo";
import CenterCodeRow from "./CenterCodeRow";
import { Circle } from "@mui/icons-material";
import { displayDateTime } from "../../utils/utils";
import { TFunction } from "i18next";
import { Tooltip } from "@mui/material";

type Props = Readonly<{
    client: Client;
    companyId: number;
    t: TFunction<"translation", undefined>;
}>;

const centerOnlineStatusColor = (lastSeenAt: Date): string => {
    const isOlderThanOneDay = Date.now() - lastSeenAt.getTime() > 1000 * 60 * 60 * 24;
    return isOlderThanOneDay ? colors.red00 : colors.green00;
};

const CenterOnlineStatusIndicator: React.FC<{ client: Client; t: TFunction<"translation", undefined> }> = ({
    client,
    t,
}) => {
    const lastSeenAt = client.lastSeenAt;

    if (!lastSeenAt) {
        return <></>;
    }

    const color = centerOnlineStatusColor(lastSeenAt);
    const lastSeenAtString = displayDateTime(lastSeenAt);
    const title = `${t("centers.lastSeenAt")}: ${lastSeenAtString}`;

    return (
        <Tooltip title={title}>
            <Circle style={{ color: color, fontSize: "1em", outline: "black" }} />
        </Tooltip>
    );
};

export const CentersRow: React.FC<Props> = ({ client, companyId, t }) => {
    const [expanded, setExpanded] = React.useState<boolean>(false);

    return (
        <>
            <TableRow key={client.id} onClick={() => setExpanded(!expanded)} style={{ cursor: "pointer" }}>
                <TableCell>
                    <span className="text-black">{client.code}</span>
                    <span style={{ paddingLeft: "1em" }}>
                        {client.wireless ? <FontAwesomeIcon icon={faWifi} size="1x" /> : null}
                    </span>
                    <CenterOnlineStatusIndicator client={client} t={t} />
                </TableCell>
                <TableCell style={{ width: "1.8em" }}>
                    <ExpandIcons closed={!expanded} />
                </TableCell>
            </TableRow>
            {expanded && (
                <>
                    <CenterCodeRow client={client} companyId={companyId} />
                    <TableRow key={`exp_${client.id}`}>
                        <TableCell colSpan={2}>
                            <div style={borders.basicOutline}>
                                <CentersInfo client={client} />
                            </div>
                        </TableCell>
                    </TableRow>
                </>
            )}
        </>
    );
};
